import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * This directive check if input key is an number
 * @example
 *   ```html
 *   <input onlyNumber [maxValue]="9999">
 *   ```
 */
@Directive({
  selector: '[onlyNumber]',
  standalone: true,
  providers: [],
})
export class OnlyNumberDirective {
  @Input() maxValue?: number;

  constructor(
    private readonly element: ElementRef,
    private readonly ngControl: NgControl,
    private readonly renderer: Renderer2,
  ) {}

  @HostListener('input', ['$event'])
  onInputChange($event: any) {
    const initialValue = this.element.nativeElement.value;
    const newValue = initialValue.replaceAll(/\D*/g, '');

    if (newValue === '' || (this.maxValue && initialValue > this.maxValue)) {
      this.ngControl.control?.setValue(null);
      $event.preventDefault(); // Prevent the default Enter key behavior
      this.showError();
      return;
    }

    if (initialValue === newValue) {
      this.hideError();
    } else {
      $event.stopPropagation();
    }

    const numberValue = Number.parseInt(newValue);
    this.ngControl.control?.setValue(numberValue);
  }

  private showError() {
    const error = this.element.nativeElement.parentElement.querySelector('.meal-error-message');
    if (error) {
      this.renderer.setStyle(error, 'display', 'block');
    }
  }

  private hideError() {
    const error = this.element.nativeElement.parentElement.querySelector('.meal-error-message');
    if (error) {
      this.renderer.setStyle(error, 'display', 'none');
    }
  }
}
